import { pictogramSizeMap } from '../metadata/size';

/**
 * Returns the CSS length value for the inline/block size of an image based on the size prop value passed to the Pictogram component.
 * @param size - The size prop value passed to the Pictogram component.
 * @returns The CSS length value for the inline/block size of the image.
 */
export const useImageSize = size => {
  return pictogramSizeMap[size];
};